import React from "react";
import StatPill from "./StatPill";

type PointsPillProps = {
  points: number;   // 0 is allowed
};

const PointsPill: React.FC<PointsPillProps> = ({ points }) => {
  return (
    <StatPill
      value={points}
      label="Points"
      valueClassName="text-emerald-700"
    />
  );
};

export default PointsPill;
